module.exports = __webpack_public_path__ + "img/04.b43f134d.png";